/**
 * Custom JavaScript for Aariro
 */
if (!customElements.get('product-read-more')) {
  customElements.define(
    'product-read-more',
    class ProductReadMore extends HTMLElement {
      constructor() {
        super();
        this.content = null;
        this.button = null;
        this.textSpan = null;
        this.maxHeight = 180;
        this.isExpanded = false;
      }

      connectedCallback() {
        this.content = this.querySelector('.product-read-more__content');
        this.button = this.querySelector('.product-read-more__button');
        this.textSpan = this.querySelector('.product-read-more__text');
        this.maxHeight = parseInt(this.dataset.maxHeight, 10) || 180;

        if (!this.content || !this.button) return;

        this.button.addEventListener('click', this.toggle.bind(this));

        // When inside an accordion/details, re-measure on toggle open
        const parentDetails = this.closest('details');
        if (parentDetails) {
          parentDetails.addEventListener('toggle', () => {
            if (parentDetails.open) {
              requestAnimationFrame(() => this.checkHeight());
            }
          });
        }

        // Measure on ready & window load
        requestAnimationFrame(() => this.checkHeight());
        if (document.readyState !== 'complete') {
          window.addEventListener('load', () => this.checkHeight(), { once: true });
        }
        setTimeout(() => this.checkHeight(), 250);
      }

      checkHeight() {
        if (!this.content || this.isExpanded) return;
        const scrollHeight = this.content.scrollHeight;
        if (scrollHeight > this.maxHeight + 25) {
          this.style.setProperty('--read-more-height', `${this.maxHeight}px`);
          this.classList.add('is-truncated');
          this.button.classList.remove('hidden');
        } else {
          this.classList.remove('is-truncated');
          this.button.classList.add('hidden');
        }
      }

      toggle() {
        if (this.isExpanded) {
          // Collapse
          this.classList.remove('is-expanded');
          this.classList.add('is-truncated');
          if (this.textSpan) {
            this.textSpan.textContent = this.textSpan.dataset.moreText || 'Read More';
          }
          this.isExpanded = false;

          const rect = this.getBoundingClientRect();
          if (rect.top < 80) {
            this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        } else {
          // Expand
          this.classList.remove('is-truncated');
          this.classList.add('is-expanded');
          if (this.textSpan) {
            this.textSpan.textContent = this.textSpan.dataset.lessText || 'Read Less';
          }
          this.isExpanded = true;
        }
      }
    }
  );
}

if (!customElements.get('product-urgency-timer')) {
  customElements.define(
    'product-urgency-timer',
    class ProductUrgencyTimer extends HTMLElement {
      connectedCallback() {
        this.hourEl = this.querySelector('[data-timer-hours]');
        this.minEl = this.querySelector('[data-timer-minutes]');
        this.secEl = this.querySelector('[data-timer-seconds]');
        this.type = this.dataset.timerType || 'daily_cutoff';
        this.cutoffHour = parseInt(this.dataset.cutoffHour || '17', 10);
        this.loopHours = parseInt(this.dataset.loopHours || '3', 10);
        this.fixedDate = this.dataset.fixedDate || '';

        this.startTimer();
      }

      startTimer() {
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      tick() {
        const now = new Date();
        let target;

        if (this.type === 'daily_cutoff') {
          target = new Date(now);
          target.setHours(this.cutoffHour, 0, 0, 0);
          if (now >= target) {
            target.setDate(target.getDate() + 1);
          }
        } else if (this.type === 'evergreen_loop') {
          const loopMs = this.loopHours * 3600 * 1000;
          const currentMs = now.getTime();
          const remainder = loopMs - (currentMs % loopMs);
          target = new Date(currentMs + remainder);
        } else if (this.type === 'fixed_date' && this.fixedDate) {
          target = new Date(this.fixedDate.replace(/-/g, '/'));
        } else {
          target = new Date(now);
          target.setHours(23, 59, 59, 999);
        }

        const diff = Math.max(0, target.getTime() - now.getTime());
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const pad = (n) => String(n).padStart(2, '0');

        if (this.hourEl) this.hourEl.textContent = pad(hours);
        if (this.minEl) this.minEl.textContent = pad(minutes);
        if (this.secEl) this.secEl.textContent = pad(seconds);
      }
    }
  );
}

